import { ref, reactive } from 'vue'

// Global confirm state
const globalConfirm = reactive({
  show: false,
  type: 'warning',
  title: 'ยืนยันการดำเนินการ',
  message: '',
  html: '',
  confirmText: 'ยืนยัน',
  cancelText: 'ยกเลิก',
  processing: false,
  processingText: 'กำลังดำเนินการ...',
  focusCancel: false,
  onConfirm: null,
  onCancel: null
})

export function useConfirm() {
  
  // Show confirmation dialog
  const showConfirm = (options = {}) => {
    return new Promise((resolve, reject) => {
      globalConfirm.show = true
      globalConfirm.type = options.type || 'warning'
      globalConfirm.title = options.title || 'ยืนยันการดำเนินการ'
      globalConfirm.message = options.message || ''
      globalConfirm.html = options.html || ''
      globalConfirm.confirmText = options.confirmText || 'ยืนยัน'
      globalConfirm.cancelText = options.cancelText || 'ยกเลิก'
      globalConfirm.processing = false
      globalConfirm.processingText = options.processingText || 'กำลังดำเนินการ...'
      globalConfirm.focusCancel = options.focusCancel || false

      globalConfirm.onConfirm = () => {
        resolve(true)
        hideConfirm()
      }

      globalConfirm.onCancel = () => {
        resolve(false)
        hideConfirm()
      }
    })
  }

  // Hide confirmation dialog
  const hideConfirm = () => {
    globalConfirm.show = false
    globalConfirm.processing = false
    globalConfirm.onConfirm = null
    globalConfirm.onCancel = null
  }

  // Set processing state
  const setProcessing = (processing) => {
    globalConfirm.processing = processing
  }

  // Common confirmation dialogs
  const confirmDelete = (itemName = 'รายการนี้') => {
    return showConfirm({
      type: 'error',
      title: 'ยืนยันการลบ',
      message: `คุณแน่ใจหรือไม่ที่จะลบ ${itemName}? การดำเนินการนี้ไม่สามารถยกเลิกได้`,
      confirmText: 'ลบ',
      cancelText: 'ยกเลิก',
      focusCancel: true
    })
  }

  const confirmSave = (message = 'คุณต้องการบันทึกข้อมูลหรือไม่?') => {
    return showConfirm({
      type: 'question',
      title: 'ยืนยันการบันทึก',
      message,
      confirmText: 'บันทึก',
      cancelText: 'ยกเลิก'
    })
  }

  const confirmAction = (action, message = '') => {
    return showConfirm({
      type: 'warning',
      title: `ยืนยัน${action}`,
      message: message || `คุณต้องการ${action}หรือไม่?`,
      confirmText: 'ยืนยัน',
      cancelText: 'ยกเลิก'
    })
  }

  const confirmLogout = () => {
    return showConfirm({
      type: 'question',
      title: 'ออกจากระบบ',
      message: 'คุณต้องการออกจากระบบหรือไม่?',
      confirmText: 'ออกจากระบบ',
      cancelText: 'ยกเลิก'
    })
  }

  const confirmDiscard = () => {
    return showConfirm({
      type: 'warning',
      title: 'ยกเลิกการแก้ไข',
      message: 'มีข้อมูลที่ยังไม่ได้บันทึก คุณต้องการยกเลิกการแก้ไขหรือไม่?',
      confirmText: 'ยกเลิก',
      cancelText: 'กลับไปแก้ไข',
      focusCancel: true
    })
  }

  const showSuccess = (title = 'สำเร็จ', message = 'ดำเนินการเสร็จสิ้น') => {
    return showConfirm({
      type: 'success',
      title,
      message,
      confirmText: 'ตกลง',
      cancelText: '',
      focusCancel: false
    })
  }

  const showError = (title = 'เกิดข้อผิดพลาด', message = 'กรุณาลองใหม่อีกครั้ง') => {
    return showConfirm({
      type: 'error',
      title,
      message,
      confirmText: 'ตกลง',
      cancelText: '',
      focusCancel: false
    })
  }

  const showInfo = (title, message) => {
    return showConfirm({
      type: 'info',
      title,
      message,
      confirmText: 'ตกลง',
      cancelText: '',
      focusCancel: false
    })
  }

  // Handle confirm and cancel events
  const handleConfirm = async () => {
    if (globalConfirm.onConfirm) {
      await globalConfirm.onConfirm()
    }
  }

  const handleCancel = async () => {
    if (globalConfirm.onCancel) {
      await globalConfirm.onCancel()
    }
  }

  return {
    // State
    globalConfirm,
    
    // Basic methods
    showConfirm,
    hideConfirm,
    setProcessing,
    
    // Common dialogs
    confirmDelete,
    confirmSave,
    confirmAction,
    confirmLogout,
    confirmDiscard,
    showSuccess,
    showError,
    showInfo,
    
    // Event handlers
    handleConfirm,
    handleCancel
  }
}